import { DEVELOPERS } from "../data/site";

export const Developers = () => {
  const loop = [...DEVELOPERS, ...DEVELOPERS];
  return (
    <section
      id="developers"
      data-testid="developers-section"
      className="py-20 bg-white text-[#0a1128] overflow-hidden"
    >
      <div className="container mx-auto px-6 mb-10 text-center">
        <div className="text-[10px] tracking-[0.5em] text-[#0a1128]/50 uppercase">
          Authorised channel partners
        </div>
        <h3 className="font-serif-display text-2xl md:text-3xl mt-3 italic text-[#0a1128]">
          Trusted by Dubai&apos;s leading developers
        </h3>
      </div>
      <div className="relative">
        <div className="flex gap-16 animate-marquee whitespace-nowrap w-max">
          {loop.map((d, i) => (
            <span
              key={i}
              className="font-serif-display text-2xl md:text-3xl text-[#0a1128]/40 hover:text-[#c5a059] transition-colors"
              data-testid={`developer-logo-${i}`}
            >
              {d}
            </span>
          ))}
        </div>
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent pointer-events-none" />
      </div>
    </section>
  );
};
